import { useServiceFilter } from '../../../hooks/InvoiceHooks';
import { SearchHookReturn } from './SearchHook';
import { useSearchPosts } from './SearchPostsHook';

export const useSearchServices: () => SearchHookReturn = () => {
  const serviceFilter = useServiceFilter();
  return useSearchPosts(serviceFilter);
};
